export function ListingCardSkeleton() {
  return (
    <div className="goe-card overflow-hidden">
      <div className="skeleton h-40 w-full" style={{ borderRadius: 0 }} />
      <div className="space-y-2 p-3">
        <div className="skeleton h-4 w-3/4" />
        <div className="skeleton h-3 w-1/2" />
        <div className="skeleton h-3 w-2/3" />
      </div>
    </div>
  );
}

export function PriceCardSkeleton() {
  return (
    <div className="goe-card shrink-0 p-4" style={{ width: 168 }}>
      <div className="skeleton mb-3 h-3 w-16" />
      <div className="skeleton mb-2 h-6 w-24" />
      <div className="skeleton h-3 w-12" />
    </div>
  );
}

export function RowSkeleton() {
  return (
    <div className="flex items-center gap-3 p-3">
      <div className="skeleton h-12 w-12 rounded-full" />
      <div className="flex-1 space-y-2">
        <div className="skeleton h-3.5 w-1/3" />
        <div className="skeleton h-3 w-2/3" />
      </div>
    </div>
  );
}
